<template>
    <div class="conversation-wrapper new-conversation">
        <section class="w-100">
            <div class="conversation-header px-3 py-2 d-flex jusitfy-content-center align-items-center">
                <b class="me-1">From:<span class="text-danger">*</span> </b>
                <div class="me-auto ms-4">
                    <select class="form-select" name="weekday-range" v-model="careTeam">
                        <template v-for="[key, value] in enumToMap(groupTypeEnum)" :key="key">
                            <option v-if="hasGroupPermission(value.value)" :value="value.value">
                                {{ value.name }}
                            </option>
                        </template>
                    </select>
                </div>
            </div>
            <div class="conversation-header px-3 py-2 d-flex jusitfy-content-center align-items-center">
                <div class="me-1 d-block d-md-none">
                    <a href="javascript:void(0);" @click="routeBacktoConnect"><i class="fas fa-chevron-left"></i></a>
                </div>
                <b class="me-1 text-nowrap">To: <span class="text-danger">*</span></b>
                <div class="ms-4 w-100">
                    <TypeaheadInput
                        placeholder="Start Patient Name"
                        :getData="getPatientList"
                        :value="patient"
                        v-on:valueChanged="updatePatient"
                        :isForMessaging="true"
                        focusOnInput="true"
                        tabindex="1"
                    />
                </div>
            </div>
            <div class="d-flex w-100 align-items-baseline group-name">
                <b class="me-1 ps-3" style="white-space: nowrap">Subject: <span class="text-danger">*</span></b>
                <div class="form-group w-100">
                    <input
                        type="text"
                        class="form-control border-0"
                        v-model="conversationSubject"
                        placeholder="Enter Thread Subject"
                        maxlength="250"
                        v-alphanumeric-special-only
                        tabindex="2"
                    />
                </div>
            </div>
        </section>
        <section class="conversation-body">
            <!-- DO NOT DELETE THIS SECTION -->
        </section>
        <footer class="conversation-input" :class="{ 'highlight-important': newMessage.isImportant }">
            <MessageInputHandler
                :send="sendMessage"
                :toggle-important="toggleImportant"
                :refs-name="`threadEditorRef-${Math.random()}`"
                :should-disable-send="disableSend"
                :isFamilyPortal="true"
            />
        </footer>
    </div>
</template>

<script lang="ts" src="./NewConversation.ts"></script>

<style>
.group-name {
    height: 3.85rem;
}
</style>
